import React, { useState } from 'react';
import notFoundImage from '@assets/images/avatar-default.png';
import { Avatar, Modal } from 'antd';

const AvatarField = ({ size, icon, src, disablePreview = false, ...props }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedAvatar, setSelectedAvatar] = useState(null);

    const handleAvatarClick = (avatarURL) => {
        if (disablePreview) return;

        setSelectedAvatar(avatarURL);
        if (avatarURL) {
            setIsModalVisible(true);
        }
    };

    return (
        <>
            <Avatar
                style={{ cursor: disablePreview ? 'default' : 'pointer' }}
                size={size}
                icon={icon}
                src={src}
                {...props}
                onClick={() => handleAvatarClick(src)}
            />
            <Modal
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                centered
                closable={false}
            >
                <img alt="Avatar" src={selectedAvatar ? selectedAvatar : notFoundImage} style={{ width: '100%' }} />
            </Modal>
        </>
    );
};

export default AvatarField;